import {Spin} from "antd";
import {SpecAdCard} from "../uiUtils/ItemCard";
import React, {useContext, useEffect, useState} from "react";
import {AppController} from "../App";
import {SpecAdAction} from "../share/SpecAdAction";
import {getDownloadMenu, getShareMenu} from "../uiUtils/Helpers";
import {reject} from "lodash";
import {ClientBridge} from "../index";

// Note pulling from SalesSheet rather than a separate search

// todo ? passin delete & download
export function SpecAdResults({salesSheet, advertiser, goToWizard, openGallery, ...props}) {

    const controller = useContext(AppController);
    const {mccNav, wizard, mcc} = useContext(ClientBridge);

    const [specAd, setSpecAd] = useState({});
    const [shareAction, setShareAction] = useState();
    const [data, setData] = useState([]);
    const [assetAuth, setAssetAuth] = useState(true);

    useEffect(()=>{
        if (salesSheet){
            setData(salesSheet.specAds);
        }
    },[salesSheet])

    //const {data, error, isPending:loading} = useAodSearch({objType:'specAd',searchBy:salesSheet,id:salesSheet.id});
    //const data= orderBy(salesSheet.specAds,salesSheet.specAdOrder) || [], error=false, loading=false;
    //const data = salesSheet.specAds || []
    const error = false, loading = false;

    function onAction(specAd,action){
        if (action==='Info View'){
            mccNav.infoView(specAd.renderInfo.template);
        }else {
            const template = new mcc.Asset(specAd.renderInfo.template);
            setSpecAd(specAd);
            setAssetAuth(wizard.assetAuth(template));
            setShareAction(action);
        }
    }

    function onDelete(specAd){
        salesSheet.specAds = reject(salesSheet.specAds, {id: specAd.id});
        setData(salesSheet.specAds);
        controller.deleteSpecAd(specAd, salesSheet);
    }

    return <div>
        <Spin spinning={loading}>
            {data && data.map((sa,i) => <SpecAdCard
                asset={sa}
                onCopy={() => goToWizard({salesSheet, specAd:sa})}
                shareMenu={getShareMenu({item:sa,onAction})}
                downloadMenu={getDownloadMenu({item:sa,onAction})}
                onDelete={()=>onDelete(sa)}
                onMcc={()=>onAction(sa, 'Info View')}
                onView={()=>openGallery(i)}
                key={sa.id}
            />)}
            {error && <span>Search failed</span>}
        </Spin>

        <SpecAdAction advertiser={advertiser} salesSheet={salesSheet}
                      specAdUnsaved={false} specAd={specAd}
                      action={shareAction} onActionDone={()=>setShareAction('')}
                      assetAuth={assetAuth}
        />
    </div>;
}
